type Color = {
    [key: string]: { light: string; dark?: string }
}

export const CriticalityColor: Color = Object.freeze({
    NONE: { light: 'transparent' },
    CRITICAL: { light: '#590409', dark: 'var(--live-criticality-none)' },
    HIGH: { light: '#B72025', dark: '#FFE1DB' },
    MEDIUM: { light: '#8E0D13', dark: '#FFB029' },
    LOW: { light: '#CD3209', dark: '#FDF3DB' },
    INFO: { light: '#006EAD', dark: '#64CEFB' }
})

export const CriticalityBgColor: Color = Object.freeze({
    NONE: { light: 'transparent' },
    CRITICAL: { light: '#8E0D13', dark: '#CD3209' },
    HIGH: { light: '#FA7272', dark: '#E73737' },
    MEDIUM: { light: '#F27400', dark: '#F27400' },
    LOW: { light: '#FDC361', dark: '#FDF3DB' },
    INFO: { light: '#64CEFB', dark: '#006EAD' }
})

export const CriticalityChartColor: Color = Object.freeze({
    NONE: { light: 'transparent' },
    CRITICAL: { light: 'var(--live-criticality-critical)' },
    HIGH: { light: 'var(--live-criticality-high)' },
    MEDIUM: { light: 'var(--live-criticality-medium)' },
    LOW: { light: 'var(--live-criticality-low)' },
    INFO: { light: 'var(--live-criticality-info)' }
})

export const CriticalityBorderColor: Color = Object.freeze({
    NONE: { light: 'transparent' },
    CRITICAL: { light: 'var(--beam-color-alert_600)', dark: 'var(--beam-color-alert_500)' },
    HIGH: { light: 'var(--beam-color-page-alert--error)' },
    MEDIUM: { light: 'var(--beam-color-warm_400)', dark: 'var(--beam-color-warm_200)' },
    LOW: { light: 'var(--beam-color-warning_200)', dark: 'var(--beam-color-warning_100)' },
    INFO: { light: 'var(--beam-color-section-alert-icon--infoPrimary)' }
})

export const CriticalityBgBlinkColor: Color = Object.freeze({
    NONE: { light: 'transparent' },
    CRITICAL: { light: '#ECC9C940', dark: '#6E121233' },
    HIGH: { light: '#FFE1DB59', dark: '#6B2D2033' },
    MEDIUM: { light: '#FDF3DB80', dark: '#67511D33' },
    LOW: { light: '#FDFCED80', dark: '#625E2633' },
    INFO: { light: '#EDFBFD80', dark: '#1F5C6733' }
})

export const CriticalityWidgetBorderColor: Color = Object.freeze({
    NONE: { light: 'transparent' },
    CRITICAL: { light: 'var(--beam-color-alert_500)' },
    HIGH: { light: 'var(--beam-color-page-alert--error)' },
    MEDIUM: { light: 'var(--beam-color-warm_400)', dark: 'var(--beam-color-warning_200)' },
    LOW: { light: 'var(--beam-color-warm_200)', dark: 'var(--beam-color-warning_100)' },
    INFO: { light: 'var(--beam-color-page-alert--info)' }
})
